import Vue from "vue";
import VueRouter from "vue-router";
import VueCompositionAPI from "@vue/composition-api";
import { createPinia, PiniaVuePlugin } from "pinia";

import router from "./router";
import App from "./App.vue";
import { APPCallJS } from "@/utils/interactive";
import waves from "@/directive/index";

import {
  Skeleton,
  Empty,
  List,
  PullRefresh,
  Popup,
  Swipe,
  SwipeItem,
  Search,
  Image as VanImage,
  Tab,
  Tabs,
  Icon,
  Lazyload,
  Loading,
  IndexBar,
  IndexAnchor,
} from "vant";

import env from "../../src/config/env";
import "./components";

import "normalize.css/normalize.css";

import "animate.css";

// vant
import "vant/lib/dialog/style";
import "vant/lib/toast/style";
import "vant/lib/skeleton/style";
import "vant/lib/empty/style";
import "vant/lib/list/style";
import "vant/lib/swipe/style";
import "vant/lib/pull-refresh/style";
import "vant/lib/search/style";
import "vant/lib/image/style";
import "vant/lib/tab/style";
import "vant/lib/tabs/style";
import "vant/lib/icon/style";
import "vant/lib/swipe/style";
import "vant/lib/swipe-item/style";
import "vant/lib/lazyload/style";
import "vant/lib/loading/style";
import "vant/lib/index-anchor/style";
import "vant/lib/index-bar/style";

import "./assets/iconfont/iconfont.css";
import "./styles/index.scss";

// 开发测试添加 VConsole
if (env.mode && (env.mode === "test" || env.mode === "development")) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const VConsole = require("vconsole");
  new VConsole();
}

APPCallJS.start();

// vant
Vue.use(Skeleton);
Vue.use(Empty);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(PiniaVuePlugin);
Vue.use(VueRouter);
Vue.use(VueCompositionAPI);
Vue.use(waves);
Vue.use(Search);
Vue.use(VanImage);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(IndexBar);
Vue.use(IndexAnchor);

const pinia = createPinia();

new Vue({
  el: "#app",
  router,
  pinia,
  render: (h) => h(App),
});
